module.exports = __webpack_public_path__ + "static/media/discord.92e085f1.svg";